export enum FasteningType {
  Combined = 0,
}
